<form [formGroup]="analysisFormGroup" (ngSubmit)="onSubmit(analysisFormGroup.value)" novalidate>

    <div class="row">
        <div class="col-md-10 my-1">
            <mat-form-field appearance="fill">
                <mat-label>Project Code</mat-label>
                <input matInput formControlName="projectCode" required data-cy="projectCode"/>
                <mat-error *ngIf="
          analysisFormGroup.get('projectCode')?.errors?.maxlength ||
          analysisFormGroup.get('projectCode')?.errors?.pattern
        " class="invalid-feedback error">
                    Project Code cannot exceed 150 characters and the following special characters are allowed
                    <strong>(, .'' - _)</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-10 my-1">
            <mat-form-field>
                 <mat-label>Study</mat-label>
                <mat-select  formControlName="study" required disableOptionCentering  data-cy="study">
                    <mat-option *ngFor="let obj of getDropDownValues('Study')" [value]="obj.name">
                        {{obj.desc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="col-md-10 my-1" formArrayName="TargetNames">

            <div *ngFor="let analyte of TargetNames.controls; let i=index; trackBy: trackByIndex" [formGroupName]="i" data-cy="target-row">

                <mat-expansion-panel style="margin-bottom: 20px;">
                    <mat-expansion-panel-header>
                        <mat-panel-title><strong>Target Name:
                                {{analyte.get('targetName')?.value}}</strong></mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <div class="col-md-10 my-1">                          
                            <mat-form-field appearance="fill">
                                 <mat-label>Target Name</mat-label>
                                <input matInput  formControlName="targetName" required data-cy="target-name-input"/>
                            </mat-form-field>
                            <mat-error
                                *ngIf="TargetNames.controls[i].controls.targetName.invalid && (TargetNames.controls[i].controls.targetName.dirty)"
                                class="invalid-feedback error">
                                <strong> Target Name cannot exceed 150 characters and the following special characters
                                    are allowed (, . ' ' - _) </strong>
                            </mat-error>
                        </div>
                        <div class="col-md-10 my-1">
                            <div fxLayout="row" fxLayoutAlign="start center" class="radio-group-row">
                                <label class="radio-label">Select Target Type</label>
                                <mat-radio-group formControlName="TargetType" fxLayout="row" fxLayoutGap="21px" data-cy="target-type-select">
                                    <mat-radio-button value="QL" >Qualitative</mat-radio-button>
                                    <mat-radio-button value="QT">Quantitative</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div *ngIf="analyte.get('TargetType')?.value === 'QT'">
                            <div class="col-md-10 my-1" formGroupName="QT" data-cy="qt-section">
                                <div fxLayout="row" fxLayoutAlign="start center" class="radio-group-row">
                                    <label class="radio-label">Are there Negative Reverse Transcriptase Samples?</label>
                                    <mat-radio-group formControlName="QTRTsamples" fxLayout="row" fxLayoutGap="10px" data-cy="QTRTsamples">
                                        <mat-radio-button value="True" class="radio-option">Yes</mat-radio-button>
                                        <mat-radio-button value="False" class="radio-option">No</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div *ngIf="analyte.get('QT.QTRTsamples')?.value === 'True'">
                                    <mat-form-field style="margin-left: -15px;">
                                         <mat-label>%Contamination Threshold</mat-label>
                                        <mat-select
                                            formControlName="contaminationThreshold" required disableOptionCentering
                                            data-cy="contaminationThreshold">
                                            <mat-option *ngFor="let obj of getDropDownValues('contaminationThreshold')"
                                                [value]="obj.name">
                                                {{obj.desc}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="analyte.get('QT.QTRTsamples')?.value === 'False'">
                                    <div fxLayout="row" fxLayoutAlign="start center" class="radio-group-row">
                                        <label class="radio-label">Were there Spiked Samples?</label>
                                        <mat-radio-group formControlName="SpikeSamples" fxLayout="row"
                                            fxLayoutGap="70px" data-cy="SpikeSamples">
                                            <mat-radio-button value="True" class="radio-option">Yes</mat-radio-button>
                                            <mat-radio-button value="False" class="radio-option">No</mat-radio-button>
                                        </mat-radio-group>
                                    </div>

                                    <div *ngIf="analyte.get('QT.SpikeSamples')?.value === 'True'"
                                        style="margin-left: -15px;">
                                        <mat-form-field>
                                             <mat-label>Number of Spiked Copies</mat-label>
                                            <input matInput 
                                                formControlName="spikeCopies" required data-cy="spikeCopies"/>

                                            <mat-error *ngIf="analyte.get('QT.spikeCopies').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field>
                                             <mat-label>%Recovery Threshold</mat-label>
                                            <mat-select 
                                                formControlName="recoveryThreshold" required disableOptionCentering
                                              data-cy="recoveryThreshold"  >
                                                <mat-option *ngFor="let obj of getDropDownValues('recoveryThreshold')"
                                                    [value]="obj.name">
                                                    {{obj.desc}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="analyte.get('QT.SpikeSamples')?.value === 'False'">
                                        <div fxLayout="row" fxLayoutAlign="start center" class="radio-group-row">
                                            <label class="radio-label">Were there Inhibition Samples?</label>
                                            <mat-radio-group formControlName="InhibitionSamples" fxLayout="row"
                                                fxLayoutGap="70px" data-cy="InhibitionSamples">
                                                <mat-radio-button value="True"
                                                    class="radio-option">Yes</mat-radio-button>
                                                <mat-radio-button value="False"
                                                    class="radio-option">No</mat-radio-button>
                                            </mat-radio-group>
                                        </div>

                                        <div *ngIf="analyte.get('QT.InhibitionSamples')?.value === 'True'">
                                            <mat-form-field style="margin-left: -15px;">
                                                 <mat-label>Number of Spiked Copies</mat-label>
                                                <input matInput 
                                                    formControlName="spikeCopies2" required data-cy="spikeCopies2" />
                                                <mat-error *ngIf="analyte.get('QT.spikeCopies2').errors?.pattern"
                                                    class="invalid-feedback error">
                                                    Maximum numerical values of up to <strong>20 digits</strong>
                                                    preceding
                                                    the
                                                    decimal place allowed.
                                                    Maximum of <strong>3 decimal</strong> places allowed.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>



                                <div *ngIf="
                                    (analyte.get('QT.QTRTsamples')?.value === 'True' && analyte.get('QT.contaminationThreshold')?.value) ||
                                    (analyte.get('QT.QTRTsamples')?.value === 'False' && ( (analyte.get('QT.SpikeSamples')?.value === 'True' &&
                                          analyte.get('QT.spikeCopies')?.value &&
                                          analyte.get('QT.recoveryThreshold')?.value
                                        ) ||
                                        (analyte.get('QT.SpikeSamples')?.value === 'False' &&
                                          (
                                            (analyte.get('QT.InhibitionSamples')?.value === 'True' && analyte.get('QT.spikeCopies2')?.value) ||
                                            analyte.get('QT.InhibitionSamples')?.value === 'False' ))))"
                                    style="margin-left: -15px;">
                                    <div>
                                        <mat-form-field>
                                             <mat-label>General Inter Precision %CV for Back Calculated Value</mat-label>
                                            <input matInput                                             
                                                type="text" formControlName="Gen_Inter_prec_CV_Back_Calc" required data-cy="Gen_Inter_prec_CV_Back_Calc"/>
                                            <mat-error
                                                *ngIf="analyte.get('QT.Gen_Inter_prec_CV_Back_Calc')?.errors?.max || analyte.get('QT.Gen_Inter_prec_CV_Back_Calc')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    2 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field>
                                             <mat-label>LLOQ/ULOQ Inter Precision %CV for Back Calculated Value</mat-label>
                                            <input matInput                                             
                                                type="text" formControlName="LLOQ_ULOQ_Inter_prec_CV_Back_Calc"
                                                required data-cy="LLOQ_ULOQ_Inter_prec_CV_Back_Calc"/>
                                            <mat-error
                                                *ngIf="analyte.get('QT.LLOQ_ULOQ_Inter_prec_CV_Back_Calc')?.errors?.max || analyte.get('QT.LLOQ_ULOQ_Inter_prec_CV_Back_Calc')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    2 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field>
                                             <mat-label>General Intra and Inter Accuracy %RE for Back Calculated Value </mat-label>
                                            <input matInput                                             
                                                type="text" formControlName="Gen_Intra_Inter_Acc_RE_Back_Calc" required data-cy="Gen_Intra_Inter_Acc_RE_Back_Calc"/>
                                            <mat-error
                                                *ngIf="analyte.get('QT.Gen_Intra_Inter_Acc_RE_Back_Calc')?.errors?.max || analyte.get('QT.Gen_Intra_Inter_Acc_RE_Back_Calc')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    2 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field>
                                             <mat-label>LLOQ/ULOQ Inter and Intra Accuracy %RE for Back Calculated Value</mat-label>
                                            <input matInput                                      
                                                type="text" formControlName="ULOQ_LLOQ_Inter_Intra_RE_Back_Calc"
                                                required data-cy="ULOQ_LLOQ_Inter_Intra_RE_Back_Calc"/>
                                            <mat-error
                                                *ngIf="analyte.get('QT.ULOQ_LLOQ_Inter_Intra_RE_Back_Calc')?.errors?.max || analyte.get('QT.ULOQ_LLOQ_Inter_Intra_RE_Back_Calc')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    2 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field>
                                             <mat-label> Lower Slope Value </mat-label>
                                            <input matInput  type="text"
                                                formControlName="Lower_Slope_Value" required data-cy="Lower_Slope_Value"/>
                                            <mat-error *ngIf=" analyte.get('QT.Lower_Slope_Value')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    20 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <mat-form-field>
                                             <mat-label> Higher Slope Value</mat-label>
                                            <input matInput  type="text"
                                                formControlName="Higher_Slope_Value" required data-cy="Higher_Slope_Value"/>
                                            <mat-error *ngIf="analyte.get('QT.Higher_Slope_Value')?.errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum <strong>numerical</strong> values of up to
                                                <strong>100</strong>
                                                allowed. Maximum of<strong>
                                                    20 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <label> <u> Select for the Following Intra Precision:</u></label>

                                        <input type="checkbox" id="Cq-{{i}}" value="false" formControlName="displayCq"
                                            (change)="updateValidity(i)">
                                        <label for="Cq-{{i}}"> Ct</label>

                                        <input type="checkbox" id="BackCalculated-{{i}}" value="false"
                                            formControlName="displayBackCalculated"
                                            (change)="updateValidityBackCalc(i)">
                                        <label for="BackCalculated-{{i}}"> Back Calculated</label>

                                        <div
                                            *ngIf="(analyte.get('QT.displayCq')?.value === false || analyte.get('QT.displayCq')?.value === null) && (analyte.get('QT.displayBackCalculated')?.value === false || analyte.get('QT.displayBackCalculated')?.value === null)">
                                            <p class="alert alert-warning">Please select at least one checkbox.</p>
                                        </div>

                                    </div>

                                    <div *ngIf="analyte.get('QT.displayCq')?.value === true" formGroupName="Cq">
                                        <div class="col-md-9 my-1">
                                            <mat-form-field>
                                                 <mat-label>Intra Precision %CV for Ct Value </mat-label>
                                                <input matInput 
                                                    type="text" formControlName="Intra_prec_CV_Cq" required data-cy="Intra_prec_CV_Cq" />
                                                <mat-error
                                                    *ngIf="analyte.get('QT.Cq.Intra_prec_CV_Cq')?.errors?.pattern"
                                                    class="invalid-feedback error">
                                                    Maximum <strong>numerical</strong> values of up to
                                                    <strong>100</strong>
                                                    allowed. Maximum of
                                                    <strong>2 decimal</strong> places allowed.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div *ngIf="analyte.get('QT.displayBackCalculated')?.value === true"
                                        formGroupName="BackCalculated">
                                        <div class="col-md-9 my-1">
                                            <mat-form-field>
                                                 <mat-label>General Intra Precision %CV for Back Calculated Value</mat-label>
                                                <input matInput                                                 
                                                    type="text" formControlName="Gen_Intra_prec_CV_Back_Calc" required data-cy="Gen_Intra_prec_CV_Back_Calc"/>
                                                <mat-error
                                                    *ngIf="analyte.get('QT.BackCalculated.Gen_Intra_prec_CV_Back_Calc')?.errors?.pattern"
                                                    class="invalid-feedback error">
                                                    Maximum <strong>numerical</strong> values of up to
                                                    <strong>100</strong>
                                                    allowed. Maximum of
                                                    <strong>2 decimal</strong> places allowed.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-9 my-1">
                                            <mat-form-field>
                                                 <mat-label>LLOQ/ULOQ Intra Precision %CV for Back Calculated Value</mat-label>
                                                <input matInput                                               
                                                    type="text" formControlName="LLOQ_ULOQ_Intra_prec_CV_Back_Calc"
                                                    required data-cy="LLOQ_ULOQ_Intra_prec_CV_Back_Calc">
                                                <mat-error
                                                    *ngIf="analyte.get('QT.BackCalculated.LLOQ_ULOQ_Intra_prec_CV_Back_Calc')?.errors?.pattern"
                                                    class="invalid-feedback error">
                                                    Maximum <strong>numerical</strong> values of up to
                                                    <strong>100</strong>
                                                    allowed. Maximum of
                                                    <strong>2 decimal</strong> places allowed.
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>


                                    <div formGroupName="QualityControls">
                                        <label for="Quality Controls"><u> Quality Controls</u></label>
                                        <mat-form-field>
                                             <mat-label>True LLOQ Nominal Value</mat-label>
                                            <input matInput 
                                                formControlName="LLOQ_QC" type="text" required data-cy="LLOQ_QC"/>
                                            <mat-error *ngIf="analyte.get('QT.QualityControls.LLOQ_QC').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field>
                                             <mat-label>Low QC Nominal Value</mat-label>
                                            <input matInput  formControlName="Low_QC"
                                                type="text" required data-cy="Low_QC"/>
                                            <mat-error *ngIf="analyte.get('QT.QualityControls.Low_QC').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field>
                                             <mat-label>Mid QC Nominal Value</mat-label>
                                            <input matInput  formControlName="Mid_QC"
                                                type="text" required data-cy="Mid_QC">
                                            <mat-error *ngIf="analyte.get('QT.QualityControls.Mid_QC').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field>
                                             <mat-label>High QC Nominal Value</mat-label>
                                            <input matInput 
                                                formControlName="High_QC" type="text" required data-cy="High_QC"/>
                                            <mat-error *ngIf="analyte.get('QT.QualityControls.High_QC').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field>
                                             <mat-label>True ULOQ Nominal Value</mat-label>
                                            <input matInput 
                                                formControlName="ULOQ_QC" type="text" required data-cy="ULOQ_QC" />
                                            <mat-error *ngIf="analyte.get('QT.QualityControls.ULOQ_QC').errors?.pattern"
                                                class="invalid-feedback error">
                                                Maximum numerical values of up to <strong>20 digits</strong>
                                                preceding
                                                the
                                                decimal place allowed.
                                                Maximum of <strong>3 decimal</strong> places allowed.
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div *ngIf="analyte.get('TargetType')?.value === 'QL'">
                            <div class="col-md-10 my-1" formGroupName="QL" data-cy="ql-section">

                                <div fxLayout="row" fxLayoutAlign="start center" class="radio-group-row">
                                    <label class="radio-label">Are there Negative Reverse Transcriptase Samples?</label>
                                    <mat-radio-group formControlName="QLRTsamples" fxLayout="row" fxLayoutGap="70px" data-cy="QLRTsamples">
                                        <mat-radio-button value="True" class="radio-option">Yes</mat-radio-button>
                                        <mat-radio-button value="False" class="radio-option">No</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <mat-form-field style="margin-left: -15px;">
                                     <mat-label>Intra %CV Threshold of Replicate Ct Values</mat-label>
                                    <input matInput 
                                        formControlName="Intra_percent_CV" required data-cy="Intra_percent_CV">
                                    <mat-error
                                        *ngIf="analyte.get('QL.Intra_percent_CV')?.errors?.max || analyte.get('QL.Intra_percent_CV')?.errors?.pattern"
                                        class="invalid-feedback error">
                                        Maximum <strong>numerical</strong> values of up to
                                        <strong>100</strong>
                                        allowed. Maximum of<strong>
                                            2 decimal</strong> places allowed.
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field style="margin-left: -15px;">
                                     <mat-label>%CV Threshold of Housekeeping and Test Sample Ct Values</mat-label>
                                    <input matInput                                    
                                        formControlName="Threshold_CV" required data-cy="Threshold_CV">
                                    <mat-error
                                        *ngIf="analyte.get('QL.Threshold_CV')?.errors?.max || analyte.get('QL.Threshold_CV')?.errors?.pattern"
                                        class="invalid-feedback error">
                                        Maximum <strong>numerical</strong> values of up to
                                        <strong>100</strong>
                                        allowed. Maximum of<strong>
                                            2 decimal</strong> places allowed.
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>


                    </div>
                    <div style="text-align: right;">
                        <button class="btn btn-danger" type="button" (click)="removeAnalyte(i)" data-cy="delete-analyte-btn"
                            style="margin-top:10vh">Remove Target</button>
                    </div>
                </mat-expansion-panel>
            </div>
            <div>
                <button mat-raised-button type="button" (click)="addAnalyte()" data-cy="add-target-btn"
                    style="float: left; background-color: #216421;color: white;">Add Target</button>
            </div>
        </div>

    </div>

    <div>
        <button class="btn btn-primary m-1 my-5" color="primary" type="submit" matStepperNext data-cy="submit-btn"
            [disabled]="submitDisabled">Submit
            Form
        </button>

    </div>


</form>